<div class="modal-body">
  <div class="row">
    <div class="col-xs-12 text-modal">
      <div class="flex-box">
        <img src="assets/images/loading.gif" alt="Carregando" />
        <div class="conteudo">
          <h4>Validando a foto e biometria do cliente.</h4>
          <h4>Aguarde...</h4>
        </div>
      </div>
    </div>
  </div>
</div>
